import styles from './styles.module.scss';
import NewCardRow from '@components/cards/new_card_row';
import CardRow from '@components/cards/card_row';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useUserContext } from '@hooks/context/useUserContext';
import { useVerificationGuard } from '@hooks/helpers/useVerificationGuard';
import Skeleton from '@components/common/skeleton';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { apiWalletService } from '@api';
import { ENewNotificationType } from '@enum';

const CardsSection = () => {
    // const { t } = useTranslation('sections', {
    //     keyPrefix: 'xeppt_cards.cards'
    // });
    const navigate = useNavigate();
    const { isDataLoading } = useUserContext();
    const { verifiedAction } = useVerificationGuard();

    const { data: cards, isLoading: isCardsLoading } = useApiQuery({
        method: () => apiWalletService.getCards(),
        notificationType: ENewNotificationType.CARD
    });

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <NewCardRow
                    onClick={() => verifiedAction(() => navigate(routes.order_xeppt_card))}
                />
                {isDataLoading || isCardsLoading ? (
                    <Skeleton className={styles.skeleton} />
                ) : (
                    cards?.map((item) => (
                        <CardRow
                            onClick={() => navigate(`${routes.xeppt_cards}/${item.id}`)}
                            key={item.id}
                            card={item}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default CardsSection;
